import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import UserEdit from "../components/UserEdit/UserEdit";
import { fetchUserDetail , updateUser} from "../actions/useredit";
import { fetchUserInfo } from "../actions/user";

const mapStateToProps = (state) => {
  return {
    isFetching: state.userEdit.isFetching,
    detail: state.userEdit.detail,
    error: state.userEdit.error,

    user_info: state.login.user_info,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserDetail,
      fetchUserInfo,
      updateUser,

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserEdit);
